import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { showMutationError } from "utils/showMutationError";

const savePostNatalConsultation = async (
  values,
  tenantVal,
  pregnancyId,
  patientId,
  consultationId
) => {
  const axiosInstance = createAxiosInstance();

  const response = await axiosInstance.post(`${tenantVal}/postnatalconsultation`, {
    tenant: tenantVal,
    patientId,
    pregnancyId,
    bornAt: values.bornAt,
    deliveryMethod: values.deliveryMethod,
    weightAtBirth: Number(values.weightAtBirth),
    jaundice: values.jaundice ? "Yes" : "No",
    breastFeeding: values.feeding === "Breast",
    formulaFeeding: values.feeding === "Formula",
    combinationFeeding: values.feeding === "Breast and Formula combination",
    issuesOfNote: values.issuesOfNote,
    phvVisit: values.phnVisit,
    weightInG: Number(values.weight),
    lengthInCm: Number(values.length),
    headCircumferenceInCm: Number(values.headCircumference),
    crt: values.crt,
    umbilicus: values.umbilicus,
    barlowAndOrtolaniTest: values.barlowAndOrtolaniTest,
    heart: values.heart,
    fontanelles: values.fontanelles,
    buccalMucosa: values.buccalMucosa,
    feet: values.feet,
    impression: values.impression,
    plan: values.plan,
    motherGravida: values.gravida,
    motherPara: values.para,
    issueDuringOrSincePregnancy: values.issues,
    postNatalMood: values.postNatalMood,
    motherSupports: values.supports,
    motherContraception: values.contraception,
    motherMirena: values.mirena,
    id: consultationId,
  });

  return response.data?.data ?? response.data;
};

export const useSavePostnatalConsultation = (pregnancyId) => {
  const queryClient = useQueryClient();

  return useMutation({
    meta: { skipGlobalError: true },
    mutationFn: ({ values, tenantVal, patientId, consultationId }) =>
      savePostNatalConsultation(values, tenantVal, pregnancyId, patientId, consultationId),
    onSuccess: () => {
      toast.success("Post-natal consultation saved.");
      queryClient.invalidateQueries({ queryKey: ["postNatalConsultations"] });
    },
    onError: (error) => showMutationError(error),
  });
};
